export const MISSING_TOOTH_OPACITY = 0.75;
export const DEFAULT_TOOTH_OPACITY = 1;
